import { render, staticRenderFns } from "./NirDataUpdateApplications.vue?vue&type=template&id=4233c622&scoped=true&"
import script from "./NirDataUpdateApplications.vue?vue&type=script&lang=js&"
export * from "./NirDataUpdateApplications.vue?vue&type=script&lang=js&"
import style0 from "./NirDataUpdateApplications.vue?vue&type=style&index=0&id=4233c622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233c622",
  null
  
)

export default component.exports